export default __webpack_public_path__ + "static/media/relative-medium-pro.5650f2ef.woff";